/* Movatic WMS — Frontend | CesarFilho 932048016 */
import { useParams } from 'react-router-dom'
import EmbedFrame from '@/pages/embed/EmbedFrame'

/**
 * Adaptador do MFC sobre o EmbedFrame genérico (ADR-0052 F3): traduz o slug do
 * MFC para o URL de embed do MFC. Toda a lógica de iframe/loading/erro vive no
 * EmbedFrame — zero duplicação. As 20 rotas /mfc/<slug> continuam a usar
 * <MfcFrame slug="…"/> sem alteração.
 */

const MFC_ORIGIN = 'https://mfc.movaticwms.com'

type Props = { slug?: string }

export default function MfcFrame({ slug: slugProp }: Props) {
  const params = useParams()
  const slug = slugProp ?? params.slug ?? 'dashboard'
  return (
    <EmbedFrame
      src={`${MFC_ORIGIN}/ui/${slug}?embed=1`}
      title={`MFC — ${slug}`}
    />
  )
}
